import { render } from "./Tab.vue?vue&type=template&id=f200f48e&scoped=true&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=f200f48e&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f200f48e"]])

export default __exports__